import type { Styles } from 'common/types';

export const styles: Styles = {
  formContainer: {
    width: '100%',
  },
  stickyBar: {
    position: 'sticky',
    bottom: 0,
    zIndex: 10,
    mt: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
    px: 3,
    py: 1.5,
    backgroundColor: 'background.paper',
    borderTop: '1px solid',
    borderColor: 'divider',
    boxShadow: '0 -4px 20px rgba(0,0,0,0.06)',
  },
};
